export const GET_HOME_SAMPLED_TESTS = "GET_HOME_SAMPLED_TESTS";
export const GET_HOME_SAMPLED_TESTS_SUCCESS = "GET_HOME_SAMPLED_TESTS_SUCCESS";
export const GET_HOME_SAMPLED_TESTS_FAIL = "GET_HOME_SAMPLED_TESTS_FAIL";

export const GET_CHECKOUT_ITEMS = "GET_CHECKOUT_ITEMS";
export const GET_CHECKOUT_ITEMS_SUCCESS = "GET_CHECKOUT_ITEMS_SUCCESS";
export const GET_CHECKOUT_ITEMS_FAIL = "GET_CHECKOUT_ITEMS_FAIL";

export const ADD_CHECKOUT_DATA = "ADD_CHECKOUT_DATA";
export const ADD_CHECKOUT_DATA_SUCCESS = "ADD_CHECKOUT_DATA_SUCCESS";
export const ADD_CHECKOUT_DATA_FAIL = "ADD_CHECKOUT_DATA_FAIL";

export const GET_DONATION_CHECK = "GET_DONATION_CHECK";
export const GET_DONATION_CHECK_SUCCESS = "GET_DONATION_CHECK_SUCCESS";
export const GET_DONATION_CHECK_FAIL = "GET_DONATION_CHECK_FAIL";